class WimmelbuchConfigButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.boldText = this.querySelector('b');
    this.dialog = document.querySelector('wimmelbuch-config-dialog');
    if (!this.dialog) {
      this.dialog = document.querySelector('dog-talk-config-dialog');

    }
    this.button.addEventListener('click', this.handleClicked.bind(this));

    if (!this.dialog.completed) {
      this.button.classList.remove('button--tertiary');
      this.button.classList.add('button--primary');
    }

  }

  setCompleted() {
    this.boldText.innerHTML = 'Personalisierung anpassen';
    this.button.classList.remove('button--primary');
    this.button.classList.add('button--tertiary');

  }

  handleClicked(e) {
    e.preventDefault();
    this.dialog.toggleDialog();
  }
}

customElements.define('wimmelbuch-config-button', WimmelbuchConfigButton);

class WimmelbuchConfigInputBreed extends HTMLElement {
  constructor() {
    super();
    this.inputElement = this.querySelector('input');
    this.autoCompleteContainer = this.querySelector('.product-wimmelbuch__config--input-breed__autocomplete-container');
    this.buttonNext = document.querySelector('.product-wimmelbuch__config--dialog__button__next');

    this.inputElement.addEventListener('blur', this.hideAutocomplete.bind(this));
    this.inputElement.addEventListener('focus', this.showAutocomplete.bind(this));

    this.inputElement.addEventListener('input', this.handleInputChange.bind(this));
    this.handleInputChange();
  }

  handleInputChange() {
    this.autoCompleteContainer.innerHTML = '';
    const filteredData = this.inputElement.value == '' ? window.wimmelBuchConfig : window.wimmelBuchConfig.filter(item => item.animal.toLowerCase().includes(this.inputElement.value.toLowerCase()));
    console.log("First Image URL:", filteredData[0].icon);
    this.handleNameInput();
    for (const item of filteredData) {
      const option = document.createElement('div');
      option.className = 'product-wimmelbuch__config--input-breed__autocomplete-option';
      const img = document.createElement('img');
      img.src = item.icon;
      img.alt = `${item.animal}`;
      img.className = "product-wimmelbuch__config--input-breed__autocomplete-option-icon";

      option.appendChild(img);
      option.appendChild(document.createTextNode(`${item.animal}`));
      option.dataset.id = item.name;

      option.addEventListener('click', () => {
        this.inputElement.value = item.animal;
        this.autoCompleteContainer.innerHTML = '';
        this.handleNameInput();
      });

      this.autoCompleteContainer.appendChild(option);
    }
  }

  handleNameInput() {
    const exists = window.wimmelBuchConfig.some(item => item.animal.toLowerCase().trim() == this.inputElement.value.toLowerCase().trim())
    if (!exists) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
  }

  showAutocomplete() {
    this.autoCompleteContainer.style.display = 'block';
  }

  hideAutocomplete() {
    setTimeout(() => {
      this.autoCompleteContainer.style.display = 'none';
    }, 200);
  }
}

customElements.define('wimmelbuch-config-input-breed', WimmelbuchConfigInputBreed);

class WimmelbuchConfigInput extends HTMLElement {
  constructor() {
    super();
    this.inputElement = this.querySelector('input');
    this.buttonNext = document.querySelector('.product-wimmelbuch__config--dialog__button__next');

    this.inputElement.addEventListener('input', this.handleInputChange.bind(this));
    this.handleInputChange();
  }

  handleInputChange() {
    const exists = this.inputElement.value.toLowerCase().trim().length > 0
    if (!exists) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
  }

}

customElements.define('wimmelbuch-config-input', WimmelbuchConfigInput);

class WimmelbuchConfigDialog extends HTMLElement {
  constructor() {
    super();
    this.showDialog = false;
    this.step = 1;
    this.completed = false;
    this.breedInput = this.querySelector('#product-wimmelbuch__config--dialog__input-breed');
    this.nameInput = this.querySelector('#product-wimmelbuch__config--dialog__input-name');
    this.buttonNext = this.querySelector('.product-wimmelbuch__config--dialog__button__next');
    this.buttonBack = this.querySelector('.product-wimmelbuch__config--dialog__button__back');
    this.dialogStep1 = this.querySelector('#product-wimmelbuch__config--dialog__step-1');
    this.dialogStep2 = this.querySelector('#product-wimmelbuch__config--dialog__step-2');
    this.selectElement = this.querySelector("wimmelbuch-config-select-element");

    this.dialogStep3 = this.querySelector('#product-wimmelbuch__config--dialog__step-3');
    this.stepTextp = this.querySelector('.product-wimmelbuch__config--dialog__heading-step-text');
    this.dialogStep3.style.display = 'none';
    this.dialogStep2.style.display = 'none';

    this.selectedColor = null;
    this.inputCounter = this.querySelector("#product-wimmelbuch__input-counter");
    this.handleEvents();

    this.buttonNext.addEventListener('click', this.nextStep.bind(this));
    this.buttonBack.addEventListener('click', this.previousStep.bind(this));


    if (this.nameInput) {
      this.nameInput.addEventListener('input', this.handleNameInput.bind(this));
    }
  }

  handleEvents() {
    this.selectElement.addEventListener('change', (e) => {
      this.selectedColor = e.target.value;
      this.buttonNext.disabled = false;
    });
  }

  handleNameInput() {
    if (this.nameInput.value == '' || this.nameInput.value.length <= 1) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounter.innerHTML = `${this.nameInput.value.length}/14`;
  }

  saveOrder() {
    const config = window.wimmelBuchConfig.find(item => item.animal == this.breedInput.value);
    const color = config.colors[parseInt(this.selectedColor)];


    const order = {
      breed: this.breedInput.value,
      name: this.nameInput.value,
      image_hc: color.image_hc,
      image_sc: color.image_sc,
    };
    document.querySelectorAll("wimmelbuch-config-button").forEach(btn => btn.setCompleted());
    document.querySelector("wimmelbuch-stick-atc").setCompleted();
    document.querySelector('wimmelbuch-media-gallery').changeImage(order, color);
    document.querySelector("#wimmelbuchAtcButton").style.display = "block";
    document.querySelector('[name="properties[_wimmelbuch_animal]"]').value = color.handle;
    document.querySelector('[name="properties[_wimmelbuch_name]"]').value = order.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_color]"]').value = color.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_hc;
    window.scrollTo(0, 0);
    document.querySelector("media-gallery").setActiveMedia(document.querySelector(".product__media-list li").dataset.mediaId)
  }

  nextStep() {
    if (this.step == 2) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.buttonNext.innerHTML = 'Konfigurieren';
      this.buttonNext.disabled = true;

      this.dialogStep2.style.display = 'none';
      this.dialogStep3.style.display = 'block';
      this.handleNameInput();
    } else if (this.step == 1) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.selectedColor = null;
      const config = window.wimmelBuchConfig.find(item => item.animal == this.breedInput.value);
      document.querySelector('wimmelbuch-config-select-element').setElements(config.colors, this.selectedColor);
      this.dialogStep1.style.display = 'none';
      this.dialogStep2.style.display = 'block';
      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }


    } else if (this.step == 3) {
      console.log(this.selectColor)
      console.log()
      this.toggleDialog();
      this.completed = true;
      this.saveOrder();
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_step',
      'step': this.step
    });
  }

  previousStep() {
    this.buttonBack.blur();
    if (this.step == 1) {
      this.toggleDialog();
    } else if (this.step == 2) {
      this.step--;
      this.handleNameInput();
      this.dialogStep1.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.dialogStep2.style.display = 'none';
      this.stepTextp.innerHTML = this.step;
      if (!this.breedInput.value) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }
    } else if (this.step == 3) {
      this.completed = false;

      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }

      this.buttonNext.innerHTML = 'Weiter';

      this.dialogStep2.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.step--;
      this.stepTextp.innerHTML = this.step;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'wimmelbuch_step',
        'step': this.step
      });
    }
  }

  toggleDialog() {
    this.showDialog = !this.showDialog;
    this.querySelector('.product-wimmelbuch__config--dialog').style.display = this.showDialog ? 'flex' : 'none';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_toggle',
      'open': this.showDialog
    })
  }
}

customElements.define('wimmelbuch-config-dialog', WimmelbuchConfigDialog);


class DogTalkConfigDialog extends WimmelbuchConfigDialog {
  constructor() {
    super();
    this.dialogStep4 = this.querySelector('#product-wimmelbuch__config--dialog__step-4');
    this.dialogStep4.style.display = 'none';
    this.selectShape = this.querySelector("#product-wimmelbuch__config--dialog__step-3 wimmelbuch-config-select-element");
    this.selectColor = this.querySelector("#product-wimmelbuch__config--dialog__step-4 wimmelbuch-config-select-element");
    this.inputCounterBreed = this.querySelector("#product-wimmelbuch__input-breed-counter");
    this.selectShape.addEventListener('change', (e) => {
      this.selectedShape = e.target.value;
      this.buttonNext.disabled = false;
    });

    this.selectColor.addEventListener('change', (e) => {
      console.log("checked: ",e);
      this.selectedColor = e.target.value;
      this.buttonNext.disabled = false;
    });

    if (this.breedInput) {
      this.breedInput.addEventListener('input', this.handleBreedInput.bind(this));
    }

  }

  handleInput(){
    if (this.nameInput.value.length == 0) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounter.innerHTML = `${this.nameInput.value.length}/14`;
  }

  handleBreedInput(){
    if (this.breedInput.value.length == 0) {
      this.buttonNext.disabled = true;
    } else {
      this.buttonNext.disabled = false;
    }
    this.inputCounterBreed.innerHTML = `${this.breedInput.value.length}/14`;
  }

  
  handleEvents() {

  }

  nextStep() {
    console.log("currentStep:", this.step);
    if (this.step == 2) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.buttonNext.disabled = true;

      this.dialogStep2.style.display = 'none';
      this.dialogStep3.style.display = 'block';
      console.log(this.selectedColor);
      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }
    } else if (this.step == 1) {
      this.step++;
      this.stepTextp.innerHTML = this.step;
      this.dialogStep1.style.display = 'none';
      this.dialogStep2.style.display = 'block';
      this.handleBreedInput();
     

    } else if (this.step == 3) {

      //this.selectedColor = null;
      this.step++;
      this.stepTextp.innerHTML = this.step;
      const colors = window.wimmelBuchConfig[this.selectedShape - 1].colors;
      document.querySelector('#product-wimmelbuch__config--dialog__step-4 wimmelbuch-config-select-element').setElements(colors, this.selectedColor);
      this.dialogStep3.style.display = 'none';
      this.dialogStep4.style.display = 'block';
      if (this.selectedColor == null) {
        this.buttonNext.disabled = true;
      } else {
        this.buttonNext.disabled = false;
      }
      console.log("Selected Shape:", this.selectedShape);

    } else if (this.step == 4) {

      this.toggleDialog();
      this.completed = true;
      this.saveOrder();
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'wimmelbuch_step',
      'step': this.step
    });
  }

  previousStep() {
    this.buttonBack.blur();
    if (this.step == 1) {
      this.toggleDialog();
    } else if (this.step == 2) {
      this.step--;
      this.dialogStep1.style.display = 'block';
      this.dialogStep3.style.display = 'none';
      this.dialogStep2.style.display = 'none';
      this.stepTextp.innerHTML = this.step;
      this.handleNameInput();
    } else if (this.step == 3) {
      this.dialogStep1.style.display = 'none';
      this.dialogStep3.style.display = 'none'; 
      this.dialogStep2.style.display = 'block';

      this.handleBreedInput()
      this.step--;
      this.stepTextp.innerHTML = this.step;

    } else if (this.step == 4) {
      this.completed = false;

      this.buttonNext.disabled = false;
   
      this.buttonNext.innerHTML = 'Weiter';

      this.dialogStep3.style.display = 'block';
      this.dialogStep4.style.display = 'none';
      this.step--;
      this.stepTextp.innerHTML = this.step;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'wimmelbuch_step',
        'step': this.step
      });
    }
  }

  saveOrder() {
    const colors = window.wimmelBuchConfig[parseInt(this.selectedShape) - 1].colors;
    const color = colors[parseInt(this.selectedColor)];
    console.log("Selected Color:", color);

    const order = {
      owner: this.breedInput.value,
      name: this.nameInput.value,
      image_hc: color.image_hc,
      image_sc: color.image_sc,
    };
    console.log("Order:", order);
    document.querySelectorAll("wimmelbuch-config-button").forEach(btn => btn.setCompleted());
    document.querySelector("wimmelbuch-stick-atc").setCompleted();
    document.querySelector('dogtalk-media-gallery').changeImage(order, color);
    document.querySelector("#wimmelbuchAtcButton").style.display = "block";
    document.querySelector('[name="properties[_wimmelbuch_animal]"]').value = color.handle;
    document.querySelector('[name="properties[_wimmelbuch_name]"]').value = order.name.trim();
    document.querySelector('[name="properties[_wimmelbuch_owner]"]').value = order.owner.trim();
    document.querySelector('[name="properties[_wimmelbuch_color]"]').value = color.name.trim();
    if(color.image_hc.includes("no-image")){
      document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_sc;
    } else {
      document.querySelector('[name="properties[_wimmelbuch_image]"]').value = color.image_hc;
    }

    window.scrollTo(0, 0);
    document.querySelector("media-gallery").setActiveMedia(document.querySelectorAll(".product__media-list li")[1].dataset.mediaId)
  }
}
customElements.define('dog-talk-config-dialog', DogTalkConfigDialog);

class WimmelbuchTab extends HTMLElement {
  constructor() {
    super();
    this.tab = this.querySelector('.product-wimmelbuch__collapsible--header');
    this.tab.addEventListener('click', this.handleTabClick.bind(this));
  }

  handleTabClick() {
    const tabContent = this.querySelector('.product-wimmelbuch__collapsible--header');
    tabContent.classList.toggle('active');
  }
}

customElements.define('wimmelbuch-tab', WimmelbuchTab);


class WimmelbuchMediaGallery extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      const selectableImages = Array.from(document.querySelectorAll(".product__media-list img"))
      const isWimmelBuch = !selectableImages.some((img) => img.src.includes("if-my-dog-could-talk"))

      if (!isWimmelBuch) {
        const defaultOrder = {
          name: "Charly",
          breed: "Dobberman",
        }
        const defaultColor = {
          image_hc: document.querySelector(".wimmelbuch-layer-image image")?.getAttribute("href") || "",
          image_sc: document.querySelectorAll(".wimmelbuch-layer-image image")[1]?.getAttribute("href") || "",
        }
        this.changeImage(defaultOrder, defaultColor)
      }
    }, 100) // Small timeout to ensure DOM is ready
  }


  _enalbeLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'block';
  }

  _disableLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'none';
  }

  changeImage(order, color) {
    this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.innerHTML = `${order.name}?`);
    const diff = (order.name.length - 8);
    if (diff > 0) {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `${(36 - (diff * 2.25))}px`));
    } else {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `36px`));
    }
    const images = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));
    images[0]?.setAttribute('href', color.image_hc);
    images[1]?.setAttribute('href', color.image_sc);
    
    //const mainImages = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));
    //console.log("Main Image(s):", mainImages.map(img => img.getAttribute('href')));

  }
}

customElements.define('wimmelbuch-media-gallery', WimmelbuchMediaGallery);

class DogTalkMediaGallery extends HTMLElement {
  constructor() {
    super();
    //this.addCornerCafeFont();
    setTimeout(() => {
      const selectableImages = Array.from(document.querySelectorAll(".product__media-list img"))
      const isWimmelBuch = !selectableImages.some((img) => img.src.includes("if-my-dog-could-talk"))

      if (!isWimmelBuch) {
        const defaultOrder = {
          name: "Charly",
          breed: "Dobberman",
        }
        const defaultColor = {
          image_hc: document.querySelector(".wimmelbuch-layer-image image")?.getAttribute("href") || "",
          image_sc: document.querySelectorAll(".wimmelbuch-layer-image image")[1]?.getAttribute("href") || "",
        }
        this.changeImage(defaultOrder, defaultColor)
      }
    }, 100) // Small timeout to ensure DOM is ready
  }

  addCornerCafeFont() {
    return;
    // Check if the font style is already added to avoid duplicates
    if (!document.getElementById('corner-cafe-font')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = 'corner-cafe-font';
      
      // Try multiple possible paths to the font
      styleSheet.innerHTML = `
        @font-face {
          font-family: 'CornerCafe';
          src: url('CORNERCAFE-1J2W4.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `;
      document.head.appendChild(styleSheet);
      console.log("CornerCafe font style added to document head");
    }
  }

  _enalbeLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'block';
  }

  _disableLoading() {
    this.querySelector('.wimmelbuch-media-gallery__item .loader').display = 'none';
  }

  changeImage(order, color) {
    this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.innerHTML = `${order.name}`);
    const diff = (order.name.length - 8);
    if (diff > 0) {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `${(46 - (diff * 2.25))}px`));
    } else {
      this.querySelectorAll('.wimmelbuch-overlay--text text').forEach(item => item.setAttribute("font-size", `46px`));
    }
    const images = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));
    if(color.image_hc.includes("no-image")){
      images[0]?.setAttribute('href', color.image_sc);
      images[1]?.setAttribute('href', color.image_sc);
    } else {
      images[0]?.setAttribute('href', color.image_hc);
      images[1]?.setAttribute('href', color.image_hc);      
    }
    
    //const mainImages = Array.from(document.querySelectorAll('.wimmelbuch-layer-image image'));
    //console.log("Main Image(s):", mainImages.map(img => img.getAttribute('href')));

    const selectableImages = Array.from(document.querySelectorAll('.product__media-list img'));
    //console.log("Selectable Images:", selectableImages.map(img => img.src));
    const isWimmelBuch = !selectableImages.some(img => img.src.includes("if-my-dog-could-talk"));
    console.log("Is Wimmelbuch:", isWimmelBuch);

    if (!isWimmelBuch && false) {
      //this.addCornerCafeFont();

      if (selectableImages.length > 0) {
        const firstSelectableImage = selectableImages[0];
        const container = firstSelectableImage.parentElement;
        if (getComputedStyle(container).position === 'static') {
          container.style.position = 'relative';
        }
        
        let textOverlay = container.querySelector('.text-overlay');
        if (!textOverlay) { 
          textOverlay = document.createElement('div');
          textOverlay.className = 'text-overlay';
         
          textOverlay.style.position = 'absolute';
          textOverlay.style.top = '72%';
          textOverlay.style.left = '67%';
          textOverlay.style.transform = 'translate(-50%, -50%)';
          textOverlay.style.width = '100%';
          textOverlay.style.textAlign = 'center';
          textOverlay.style.fontSize = '36px';
          textOverlay.style.fontWeight = 'bold';
          textOverlay.style.color = 'rgb(158, 73, 56)';
          textOverlay.style.textShadow = '1px 1px 2px white';
          textOverlay.style.pointerEvents = 'none';
          textOverlay.style.fontFamily = "'CornerCafe', cursive";
          
          container.appendChild(textOverlay);
        }
        textOverlay.textContent = order.name.toUpperCase();
      }
    }
  }
}

customElements.define('dogtalk-media-gallery', DogTalkMediaGallery);


class WimmelbuchConfigSelectElement extends HTMLElement {
  constructor() {
    super();
    console.log("name: ", this.getAttribute('name'));
    
    this.name = this.getAttribute('name') || 'color';
  }

  setElements(elements, selectedColor) {
    var html = '<div class="grid grid--2-col grid--3-col-tablet">';
    elements.forEach((elem, index) => {
      html += `<div class="grid__item"><input type="radio" name="${this.name}" value="${index}" ${(index == selectedColor) ? 'checked' : ''} id="${this.name}-${index}" /><label for="${this.name}-${index}"><img src="${elem.icon}" /></label></div>`;
    });
    html += '</div>'

    console.log(html);

    this.innerHTML = html;

  }
}

customElements.define('wimmelbuch-config-select-element', WimmelbuchConfigSelectElement);


class WimmelbuchStickAtc extends HTMLElement {
  constructor() {
    super();
    this.stickyAtc = this.querySelector('#stickyATC');
    this.stickyATCButton = this.querySelector('#stickyATCButton');
    this.stickyATCButton.addEventListener('click', () => {
      document.querySelector('#wimmelbuchAtcButton').click();
    });
    window.addEventListener('scroll', (event) => {
      let mainBTN = document.querySelector(
        '.product__info-wrapper .product-wimmelbuch__config--button:not(.product-wimmelbuch__AddToCart_Sticky)'
      ) // document.getElementById("mainATC");

      if (this.isOutOfViewport(mainBTN).any) {
        this.stickyAtc.classList.add('sticky')
      } else {
        this.stickyAtc.classList.remove('sticky')
      }
    })

  }
  isOutOfViewport(elem) {
    // Get element's bounding
    var bounding = elem.getBoundingClientRect()

    // Check if it's out of the viewport on each side
    var out = {}
    out.top = bounding.top < 0
    out.left = bounding.left < 0
    out.bottom =
      bounding.bottom >
      (window.innerHeight || document.documentElement.clientHeight)
    out.right =
      bounding.right > (window.innerWidth || document.documentElement.clientWidth)
    out.any = out.top || out.left || out.bottom || out.right
    out.all = out.top && out.left && out.bottom && out.right

    return out
  }

  setCompleted() {
    this.querySelector(".product-wimmelbuch__config--button").style.display = "none";
    this.querySelector("#stickATCWrapper").style.display = "block";
  }
}

customElements.define('wimmelbuch-stick-atc', WimmelbuchStickAtc);
